<template>
    <div v-if="items" class="md:w-1/2 lg:w-3/5 md:pl-8 pb-4 lg:pb-0">
        <div class="relative z-30 w-full mb-5 lg:mb-9">
            <a
                class="relative flex justify-between items-center w-full pl-5 rounded-full border border-solid lg:text-xl text-grey"
                :class="bg" 
                href="#"
                @click.prevent="show = !show"
            >
                <span>
                    <span v-if="active.location != 'Select'">Distance from</span>
                    
                    {{ active.location }}
                </span>

                <span
                    class="flex justify-center items-center w-11 h-11 rounded-full border border-solid border-white"
                    :class="page_style==='' ? 'bg-primary' : `bg-${page_style}-primary`"
                >
                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.19732 9.22748L0.347826 2.37798C-0.115942 1.94989 -0.115942 1.20072 0.347826 0.772631C0.77592 0.308863 1.52508 0.308863 1.95318 0.772631L8.01784 6.80162L14.0468 0.772631C14.4749 0.308863 15.2241 0.308863 15.6522 0.772631C16.1159 1.20072 16.1159 1.94989 15.6522 2.37798L8.80268 9.22748C8.37458 9.69125 7.62542 9.69125 7.19732 9.22748Z" fill="#3B3C4A"/>
                    </svg>
                </span>
            </a>

            <ul v-if="show" class="absolute left-0 top-full w-full mt-0.5 rounded-3xl shadow-md text-base bg-white overflow-hidden">
                <li v-for="item, index in items" :key="index">
                    <a
                        @click.prevent="distanceFrom(index)"
                        class="flex py-2 px-6 text-grey hover:text-dark cursor-pointer"
                        :class="page_style==='' ? 'hover:bg-primary' : `hover:bg-${page_style}-primary`"
                    >
                        Distance from {{ item.location }}
                    </a>
                </li>
            </ul>
        </div>

        <span v-html="active.desc" class="flex w-full justify-center lg:justify-start lg:-mt-0.5 lg:pl-5 lg:text-xl tracking-tight"></span>
    </div>    
</template>
<script>
export default {
    data(){
        return {
            show: false,
            active: {
                location: "Select",
                desc: "Distance from town",
            },
        }
    },
    props: {
        name: {
            type: String,
        },
        bg: {
            type: String,
            default: ' bg-white border-white ',
        },
        page_style: {
            type: String,
            default: '',
        },
    },
    computed: {
        items() {
            return window?.capes?.[this.name] ?? []
        },
    },
    created() {
        console.log(this.page_style)
        if( this.items.length ) {
            this.active = this.items[0]
        }
    },
    methods: {
        distanceFrom(index) {
            this.active = this.items[index]

            this.show = !this.show
        }
    },
}
</script>
